module.exports = __webpack_public_path__ + "static/media/send_email_2.26eebec6.gif";